import React from 'react'
import PropTypes from 'prop-types'

import { Tooltip } from 'react-wot-bootstrap'

import styles from './DefaultTooltip.scss'

export class DefaultTooltip extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        title: PropTypes.node,
        message: PropTypes.node,
    }
    render() {
        return (
            <Tooltip id={this.props.id}>
                <div className={styles.content}>
                    {this.props.title && (
                        <p className={styles.subtitle}>
                            {this.props.title}
                        </p>
                    )}
                    {this.props.message && (
                        <p className={styles.message}>
                            {this.props.message}
                        </p>
                    )}
                </div>
            </Tooltip>
        )
    }
}

export default DefaultTooltip



// WEBPACK FOOTER //
// ./components/DefaultTooltip/DefaultTooltip.jsx